<!--

	A wrapper of our default vimeo player component that allows to be switched to a fallback video player
	that loads video files from our S3 backups.

-->
<template>
	<div class="mia-VimeoPlayerWithFallback">
		<vimeo-player v-if="isVimeoPlayerShown" :key="vimeoPlayerKey" v-bind="$attrs" />
		<vimeo-s3-fallback-player v-else :key="fallbackPlayerKey" v-bind="$attrs" />
		<div v-if="isFallbackButtonShown" class="mia-FallbackButtonWrapper">
			<a v-if="isVimeoPlayerShown" v-tr="'vimeo_video_fallback_button'" class="btn mia-btn mia-btn-link mia-FallbackButton" @click="isVimeoPlayerShown = !isVimeoPlayerShown" />
		</div>
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import VimeoS3FallbackPlayer from "./VimeoS3FallbackPlayer.vue";
import VimeoPlayer from "./VimeoPlayer.vue";

@Component({
	components: {
		VimeoS3FallbackPlayer,
		VimeoPlayer,
	},
	inheritAttrs: false,
})
export class VimeoPlayerWithFallback extends Vue {
	@Prop({ required: true, type: Boolean }) fallbackEnabled!: boolean;
	@Prop({ required: false, type: Boolean, default: null }) showFallbackButton!: boolean;

	isFallbackButtonShown = false;
	isVimeoPlayerShown = true;

	get vimeoPlayerKey(): string {
		const videoSrc = this.$attrs.videoSrc ?? this.$attrs["video-src"];
		return `vimeo:${String(videoSrc)}`;
	}

	get fallbackPlayerKey(): string {
		const vimeoId = this.$attrs.vimeoId ?? this.$attrs["vimeo-id"];
		return `fallback:${vimeoId}`;
	}

	mounted() {
		this.isFallbackButtonShown = this.showFallbackButton ?? this.fallbackEnabled;
		this.isVimeoPlayerShown = !this.fallbackEnabled || this.isFallbackButtonShown;
	}
}

export default toNative(VimeoPlayerWithFallback);
</script>
<style lang="scss">
.mia-VimeoPlayerWithFallback {
	flex-direction: column;

	.mia-FallbackButtonWrapper {
		display: flex;
		justify-content: center;
		width: 100%;

		.mia-FallbackButton {
			white-space: normal;
		}
	}
}
</style>
